var _Label, _IncentiveBadge;
import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reaxl';

/**
 * IncentiveBadge component - renders an incentive badge for vehicles with special offers
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function IncentiveBadge() {
  return _Label || (_Label = /*#__PURE__*/_jsx(Label, {
    bsStyle: "secondary",
    "data-cmp": "IncentiveBadge",
    children: "Incentive"
  }));
}

/**
 * DealBadge component - renders a "Good Price" or "Great Price" badge based on deal indicator
 */
function DealBadge(_ref) {
  let {
    dealIndicator
  } = _ref;
  if (!dealIndicator) return null;
  let bsStyle = '';
  switch (dealIndicator) {
    case 'Good':
      bsStyle = 'secondary';
      break;
    case 'Great':
      bsStyle = 'success';
      break;
    default:
      return null;
  }
  return /*#__PURE__*/_jsx(Label, {
    bsStyle: bsStyle,
    "data-cmp": "DealBadge",
    children: `${dealIndicator} Price`
  });
}
/**
 * PricingBadges component - displays pricing-related badges including deal indicators and incentives
 */
function PricingBadges(_ref2) {
  let {
    dealIndicator,
    hasIncentive = false,
    uiContext
  } = _ref2;
  const isRecommended = uiContext === 'recommended';
  return /*#__PURE__*/_jsxs("div", {
    className: "pricing-badges",
    "data-cmp": "PricingBadges",
    children: [!isRecommended && dealIndicator && /*#__PURE__*/_jsx(DealBadge, {
      dealIndicator: dealIndicator
    }), !isRecommended && hasIncentive && (_IncentiveBadge || (_IncentiveBadge = /*#__PURE__*/_jsx(IncentiveBadge, {})))]
  });
}
export default PricingBadges;